<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t('ALTERARDATACOLETA.ALTERAR')}}</p>
        </header>
        <section class="modal-card-body">
            <b-field>
                <b-datetimepicker rounded
                                  :placeholder="$t('SISTEMA.SELECIONEDATAHORA')"
                                  icon="calendar-today"
                                  v-model="novaDataDeColeta"
                                  inline
                                  horizontal-time-picker>
                </b-datetimepicker>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                      @click="alterarDataDeColeta">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close')">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            selecionado: Array
        },
        data() {
            return {
                novaDataDeColeta: new Date()
            }
        },
        methods: {
            alterarDataDeColeta() {
                this.selecionado.forEach(x => {
                    x.logDataHora = this.novaDataDeColeta
                })
                this.$emit('close')
            }
        }
    }
</script>